import {Box, Button, Divider, IconButton, Modal, TextField, Typography} from '@mui/material';
import {Bento, CheckCircleOutline, Close, Notifications} from '@mui/icons-material';
import React, {useState} from 'react';
import {API} from '../../../utils/Constants';
import RequestSvc from '../../../services/RequestSvc';
import FollowSuccessDialog from '../../dialogs/FollowSuccessDialog';
import LoaderComponent from '../../loaders/LoaderComponent';


export default function FollowOfferWindow({showFollowOfferWindow, showHideOfferFollowWindow, item}) {

    /*  INIT VARS   */

    /**
     * Todo: por favor agregar que es esta url
     * @type {string}
     */
    const url = `https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&source=page-transparency-widget&view_all_page_id=${item.pageID}`;
    /**
     * Todo: por favor agregar que es esta url
     * @type {string}
     */
    const domainUrl = `https://www.facebook.com/ads/library/?ad_type=all&country=ALL&sort_data[direction]=desc&sort_data[mode]=relevancy_monthly_grouped&search_type=keyword_exact_phrase&media_type=all&active_status=active&q=%22${item.ahref}%22`;
    /**
     * Url href del ad
     */
    let ulrObject
    try {
        ulrObject = item.ahref ? new URL(item.ahref) : '';
    } catch (err) {
        ulrObject = '';
    }
    /**
     * Dominio del anunciante
     * @type {string|null}
     */
    const domain = ulrObject.hostname ?? null;
    /**
     * Texto para dar manejo a la descripcion cuando hace falta el dominio del anunciante
     * @type {string}
     */
    const text1 = domain ? 'o el dominio' : 'o su dominio,';
    /**
     * Cantidada de duplicados seleccionadas
     */
    const [duplicatesSelected, setDuplicatesSelected] = useState('');
    /**
     * Nombre del seguimiento.
     */
    const [offerFollowName, setOfferFollowName] = useState('');
    /**
     * Flag que indica si se debe mostrar la venta de success.
     */
    const [showSuccessWindow, setShowSuccessWindow] = useState(false);
    /**
     * FLag que indica si esta haciendo una carga.
     */
    const [isLoading, setIsLoading] = useState(false);
    /**
     * Objeto de la clase que se usa para hacer request
     * @type {RequestSvc}
     */
    const requestSvc = new RequestSvc();
    /**
     * Stylo para el layout principal
     * @type {{border: string, boxShadow: number, padding: number, transform: string, backgroundColor: string, overflow: string, top: string, borderRadius: string, left: string, width: number, position: string}}
     */
    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
        backgroundColor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        padding: 16,
        borderRadius: '20px',
        overflow: 'hidden',
    }

    /*  END VARS    */


    /*  INIT EVENTS */

    /**
     * Cerrar la ventana modal.
     */
    const handleClose = () => {
        showHideOfferFollowWindow(false, null)
    }
    /**
     * Evento que dispara cuando se agrega el nombre del follow
     * @param event
     */
    const onChangeOfferFollowNameField = (event) => {
        setOfferFollowName(event.target.value.replace(/^\s+/, ''))
    }
    /**
     * Evento que se dispara cuando se agrega la cantidad de alertas.
     * @param event
     */
    const onChangeDuplicateField = (event) => {
        setDuplicatesSelected(event.target.value);
    }
    /**
     * Evento del boton 'seguir
     */
    const onClickFollowButton = () => {
        submit();
    }

    /*  END EVENTS  */


    /* INIT METHODS */

    /**
     * Crear el seguimiento
     * @returns {Promise<void>}
     */
    const submit = async () => {
        setIsLoading(true)
        let endpoint = API.OFFER_FOLLOW;
        let payload = {
            Alerta: duplicatesSelected,
            Domain: domainUrl,
            FanPage: url,
            AnuncioUUID: item.AnuncioUUID,
            Nombre: offerFollowName
        }
        let result = await requestSvc.post(endpoint, payload);
        if (result.code !== 201) {
            alert('Ha ocurrido un error. Intenta de nuevo más tarde, o ponte en contacto con el administrador.');
            setIsLoading(false)
            handleClose();
            return;
        }
        item.OffersFollo_ID = result.data.UUID;
        item.Nombre = result.data.Nombre;
        setIsLoading(false)
        setShowSuccessWindow(true)
    }

    /* END METHODS  */

    return (
        <div className={'main-layout-modal-window'}>
            <Modal
                open={showFollowOfferWindow}
                onClose={handleClose}>
                <div style={styleBox}>
                    {
                        showSuccessWindow ? (
                            <FollowSuccessDialog onClose={handleClose}/>
                        ) : (
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                {
                                    isLoading && (
                                        <div style={{
                                            position: 'absolute',
                                            height: '100%',
                                            width: '100%',
                                            marginRight: '-16px',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 1000,
                                        }}>
                                            <LoaderComponent/>
                                        </div>
                                    )
                                }
                                <IconButton
                                    size='large'
                                    sx={{
                                        alignSelf: 'end',
                                        position: 'relative',
                                        marginTop: '-12px',
                                        marginBottom: '4px'
                                    }}
                                    onClick={handleClose}>
                                    <Close fontSize='inherit'/>
                                </IconButton>
                                <Typography
                                    id='modal-modal-title'
                                    style={{display: 'flex', justifyContent: 'space-between'}}
                                    component='h2'
                                    variant='h6'>
                                    <div style={{display: 'flex', alignItems: 'center', fontSize: '16px'}}>
                                        <Bento style={{marginRight: '4px', fontSize: '24px', fontWeight: 'bold'}}/>
                                        Nuevo seguimiento
                                    </div>
                                </Typography>
                                <Divider style={{marginTop: '16px'}}/>
                                <div
                                    style={{
                                        marginTop: '16px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}>
                                    <TextField
                                        size='small'
                                        label='Nombre del seguimiento'
                                        required
                                        onChange={onChangeOfferFollowNameField}/>
                                    {/*<TextField
                                        size='small'
                                        label='Pagina (enlace)'
                                        required
                                        value={url}
                                        onChange={(e) => {
                                            return false
                                        }}
                                        style={{marginTop: '16px'}}/>
                                    <TextField
                                        size='small'
                                        label='Dominio (enlace)'
                                        required
                                        value={domainUrl}
                                        onChange={(e) => {
                                            return false
                                        }}
                                        style={{marginTop: '16px'}}/>*/}
                                </div>
                                <p style={{
                                    marginTop: '16px',
                                    backgroundColor: '#e9f0f8',
                                    padding: '16px',
                                    textAlign: 'justify',
                                    fontSize: '13px',
                                    borderRadius: '8px',
                                    fontWeight: '400'
                                }}>
                                    <span style={{
                                        color: '#000000',
                                        fontWeight: 'bold',
                                        fontSize: '15px'
                                    }}>Nota:</span> A partir de
                                    mañana a las 7:30 a.m., haremos seguimiento diario de los anuncios en Facebook y
                                    el dominio
                                    para una comparación constante en el mismo horario.
                                </p>
                                <br/>
                                <Typography
                                    id='modal-modal-title'
                                    style={{display: 'flex', justifyContent: 'space-between'}}
                                    component='h2'
                                    variant='h6'>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <Notifications style={{marginRight: '4px', fontSize: '24px'}}/>
                                        Nueva Alerta
                                    </div>
                                </Typography>
                                <br/>
                                <TextField
                                    size='small'
                                    label='Cantidad de anuncios'
                                    type={'number'}
                                    onChange={onChangeDuplicateField}
                                    sx={{width: '190px'}}/>
                                <br/>
                                <p style={{
                                    marginTop: '4px',
                                    backgroundColor: '#e9f0f8',
                                    padding: '16px',
                                    textAlign: 'justify',
                                    fontSize: '13px',
                                    borderRadius: '8px',
                                    fontWeight: '400'
                                }}>
                                    <span style={{color: '#000000', fontWeight: '800', fontSize: '15px'}}>Nota:</span>
                                    &ensp;Recibirás esta alerta cuando la página FanPage&ensp;
                                    <span style={{
                                        color: '#000000',
                                        fontWeight: '800',
                                        fontStyle: 'italic'
                                    }}>'{item.FanPageName}'</span>
                                    &ensp;{text1}&ensp;
                                    {
                                        domain && (
                                            <span style={{
                                                color: '#000000',
                                                fontWeight: '800',
                                                fontStyle: 'italic'
                                            }}>'{domain}'&ensp; </span>
                                        )
                                    }
                                    alcancen el número de anuncios activos que hayas establecido.
                                </p>

                                <div className={'filters-component-container-buttons'}
                                     style={{
                                         display: 'flex',
                                         justifyContent: 'flex-end',
                                         marginTop: '8px'
                                     }}>
                                    <Button
                                        disabled={offerFollowName.length === 0}
                                        variant='contained'
                                        className='submitBtn'
                                        color='primary'
                                        onClick={onClickFollowButton}>
                                        Seguir
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </Modal>
        </div>
    );

}